// French by default; add an "en" dictionary here when English is enabled.
export const LOCALE = "fr";

const STATUS = {
  fr: {
    actif: ["Actif", "success"], suspendu: ["Suspendu", "danger"], candidat: ["Candidat", "info"], radie: ["Radié", "danger"],
    valide: ["Validé", "success"], en_attente_validation: ["Déclaré", "warning"], initie: ["Initié", "warning"],
    rejete: ["Rejeté", "danger"], echoue: ["Échoué", "danger"], annule: ["Annulé", "muted"],
    active: ["Active", "success"], expiree: ["Expirée", "danger"], en_attente: ["En attente", "warning"], annulee: ["Annulée", "muted"],
    approuve: ["Approuvé", "success"], soumis: ["Soumis", "info"], en_etude: ["En étude", "warning"], refuse: ["Refusé", "danger"], brouillon: ["Brouillon", "muted"],
    nouvelle: ["Nouvelle", "info"], acceptee: ["Acceptée", "success"], refusee: ["Refusée", "danger"],
    avis_parrain: ["Avis du parrain attendu", "info"], info_demandee: ["Informations demandées", "warning"], expire: ["Expiré", "danger"],
    envoyee: ["Envoyée", "info"], utilisee: ["Utilisée", "success"], demandee: ["Demandée", "info"], presentee: ["Présentée", "warning"],
    a_payer: ["À payer", "warning"], paye: ["Payé", "success"], demande: ["Demande envoyée", "info"], accepte: ["Contact", "success"],
    simule: ["Simulé", "info"], envoye: ["Envoyé", "success"], echec: ["Échec", "danger"],
    ouverte: ["Ouverte", "success"], en_cours: ["En cours", "info"], cloturee: ["Clôturée", "muted"],
    publie: ["Publié", "success"],
  },
};

const ROLES = {
  fr: {
    membre: "Membre", moderateur: "Modérateur", tresorier: "Trésorier du club", admin: "Administrateur", super_admin: "Super-administrateur",
    porteur: "Porteur", co_porteur: "Co-porteur", adherent: "Adhérent à l'opération", interesse: "Intéressé",
  },
};

const PURPOSES = {
  fr: { cotisation_annuelle: "Cotisation annuelle", frais_service: "Frais de service", billet: "Billet", part_operation: "Part d'opération" },
};

const METHODS = { fr: { wave: "Wave", virement: "Virement", especes: "Espèces", orange_money: "Orange Money", mtn_momo: "MTN MoMo" } };

export const statusInfo = (s) => STATUS[LOCALE][s] || [s, "muted"];
export const roleLabel = (r) => ROLES[LOCALE][r] || r;
export const purposeLabel = (p) => PURPOSES[LOCALE][p] || p;
export const methodLabel = (m) => METHODS[LOCALE][m] || m;
